export default __webpack_public_path__ + "static/media/image15.c8a6e805.png";